export const queryKeyMutator = (options: any, queryProperties: any) => {
  // Extract path from URL template
  const url = queryProperties.url || "";
  // Build path segments: ["/task", "/task/root-task", "/task/root-task/reviews"]
  const buildPathSegments = (urlPath: string): string[] => {
    const segments: string[] = [];
    const parts = urlPath.split("/").filter(Boolean);

    let currentPath = "";
    for (const part of parts) {
      currentPath += "/" + part;
      segments.push(currentPath);
    }

    return segments;
  };

  // Create a stable query key that includes path segments and parameters
  // Format: [...pathSegments, ...flattenedParams]
  // This ensures different parameter combinations get different keys
  const flattenParams = (obj: any, prefix = ""): (string | any)[] => {
    if (obj === null || obj === undefined) return [];
    if (typeof obj !== "object") return [obj];

    return Object.entries(obj)
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)) // Sort for stable ordering
      .flatMap(([key, value]) => {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        if (value === null || value === undefined) return [];
        if (Array.isArray(value)) return [fullKey, JSON.stringify(value)];
        if (typeof value === "object") return flattenParams(value, fullKey);
        return [fullKey, value];
      });
  };

  return [...buildPathSegments(url), ...flattenParams(options)];
};
